// Import React
import React from "react";

// Import css
import "./OpenStoreButton.css";

// Import the stored app config getter
import { GetAppConfig } from "global/config/AppConfigStore";



// Reusable open store button
export default function OpenStoreButton({ alias, buttonTitle = "View Store", disabled = false}) {



    // This handles opening the store in a new tab
    const handleOpenStore = (event) => {

        // Read the loaded runtime config only when this function is called
        const config = GetAppConfig();

        // Read the configured store url
        const storeURL = config?.storeUrl || "";
        
        // Stop if there is no valid url
        if (!alias) {
            return;
        }

        // Open the store safely in a new tab
        window.open(`${storeURL}/${alias}`, "_blank", "noopener,noreferrer");

    };



    // Return the button
    return (

        <button
            type="button"
            className={`open-store-button ${!alias ? "open-store-button--disabled" : ""}`}
            onClick={(event) => {
                event.stopPropagation();
                 handleOpenStore(event)}
            } 
            disabled={!alias || disabled}
            title={alias ? buttonTitle : "No store link available"}
        >

            {/* Small storefront style icon */}
            <span className="open-store-button__icon" aria-hidden="true">

                <svg
                    viewBox="0 0 24 24"
                    className="open-store-button__svg"
                >
                    <path
                        d="M4 10L5.5 5H18.5L20 10"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M5 10H19V19H5V10Z"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M9 19V14H15V19"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M3.5 10H20.5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                    />
                </svg>

            </span>

            {/* Button text */}
            <span className="open-store-button__text">
                {buttonTitle}
            </span>

        </button>

    );

}